import Model from './model'

class TransferRelatedMessage extends Model {
  static get name() {
    return 'transfer_related_messages'
  }

  get head() {
    return JSON.parse(this.text).head
  }

  get body() {
    return JSON.parse(this.text).body
  }

  get materialIcon() {
    if (this.head.match(/completed/i) || this.head.match(/done/i)) return 'done'
    if (this.head.match(/delayed/i)) return 'warning'
    return 'event_note'
  }

  get cautionLabel() {
    if (this.head.match(/delayed/i)) return 'caution'
    return ''
  }
}

export default TransferRelatedMessage
